import React from 'react';
import { useAuth0UserInfo } from 'reactQuery/queries/useAuth0UserInfo';
import { DoctorLayout } from './';
import { DSOLayout } from '../DSO/Layout/';
import { LoadingSpinner } from 'components/core';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { data, isLoading } = useAuth0UserInfo();

  if (isLoading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
        }}
      >
        <LoadingSpinner />
      </div>
    );
  }
  const LayoutComponent =
    data?.business_unit === 'dso' ? DSOLayout : DoctorLayout;

  return <LayoutComponent>{children}</LayoutComponent>;
};

export default Layout;
